import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { openMembership } from "common/nativeBridge";
import { isStoreApp } from "common/nativeRoute";

/**
 * 스토어 앱(iOS·안드로이드)에서 멤버십 결제·요금 화면(토스)으로 들어오면 네이티브 멤버십 화면을 띄우고
 * 이전 화면으로 돌아간다. (구 IosMembershipGate — 안드로이드 Google Play 결제 출시로 확장)
 *
 * 왜 라우트에서 막는가: "/membership/MEMBERSHIP"·"/pricing" 으로 바로 이동하는 곳이 여러 군데다
 *  (공고 한도 안내·공고 작성·요금 안내·결제 결과·소개 페이지). 하나씩 고치면 새로 생기는 곳에서 또 샌다.
 *  앱 안에서는 스토어 결제(애플 인앱결제 / Google Play 결제)로만 팔 수 있어
 *  (App Store 심사 3.1.1 / Google Play 결제 정책), 토스 화면이 보이는 순간 반려·정책 위반 사유다.
 *
 * 순수 웹에서는 아무 일도 하지 않고 원래 화면을 그린다.
 */
export default function StoreMembershipGate({ children }) {
  const navigate = useNavigate();
  const storeApp = isStoreApp();

  useEffect(() => {
    if (!storeApp) return;
    openMembership({ featureType: "MEMBERSHIP" });
    // 바로 이 주소로 앱이 열린 경우(이전 기록 없음)엔 홈으로.
    if (window.history.length > 1) navigate(-1);
    else navigate("/home", { replace: true });
  }, [storeApp, navigate]);

  return storeApp ? null : children;
}
